import { Transition } from "@headlessui/react";
import {
  MinusIcon,
  PlusIcon,
  ShoppingCartIcon,
  XIcon,
} from "@heroicons/react/outline";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useCart } from "react-use-cart";
import PriceLabel from "./PriceLabel";

const CartMobile = () => {
  const { cartTotal, isEmpty, items, totalUniqueItems, updateItemQuantity } =
    useCart();
  const { t } = useTranslation();

  const [cartOpen, setCartOpen] = useState(false);

  let subtotal;

  if (items.every((item) => !item.price)) {
    subtotal = t("Price to be agreed");
  } else if (items.some((item) => !item.price)) {
    subtotal = `${t("From")} ${Number(cartTotal).toFixed(2)} €`;
  } else {
    subtotal = `${Number(cartTotal).toFixed(2)} €`;
  }

  return (
    <div className="flex mr-2 lg:hidden">
      <button
        aria-label={t("Menu")}
        className="relative"
        onClick={() => setCartOpen(true)}
      >
        <ShoppingCartIcon aria-hidden="true" className="w-6" />
        {!isEmpty && (
          <span className="absolute bg-yellow flex font-medium h-5 items-center justify-center -right-2.5 rounded-full text-sm text-abbey -top-2.5 w-5">
            {totalUniqueItems}
          </span>
        )}
      </button>

      <Transition
        show={cartOpen}
        enter="transition-opacity duration-75"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0" onClick={() => setCartOpen(false)}></div>

        <div className="bg-white fixed left-0 h-screen max-w-[90%] shadow-lg top-0 w-80 z-50">
          <div className="relative h-full px-6 pt-12 pb-6">
            <button
              aria-label={t("Close")}
              className="absolute right-6 top-4"
              onClick={() => setCartOpen(false)}
            >
              <XIcon aria-hidden="true" className="w-5" />
            </button>

            <div className="flex flex-col h-full">
              <div className="mb-4">
                <div className="pb-2 text-xl font-bold uppercase border-b-2 border-yellow">
                  {t("Cart")}
                </div>
              </div>

              {isEmpty ? (
                <span className="block mb-6 font-medium">
                  {t("Cart is empty")}
                </span>
              ) : (
                <>
                  <div className="overflow-y-hidden grow">
                    <div className="h-full overflow-y-auto">
                      <div className="space-y-4">
                        {items.map((item) => (
                          <div key={item.id}>
                            <div className="mb-2 font-medium">
                              {item.CodiceWeb || item.Codice}
                            </div>

                            <div className="flex items-center justify-between">
                              <div className="flex border border-nobel">
                                <button
                                  onClick={() =>
                                    updateItemQuantity(
                                      item.id,
                                      Math.max(0, item.quantity - 1)
                                    )
                                  }
                                  className="px-2 py-1 bg-white border-r border-nobel disabled:bg-gray-100"
                                >
                                  <MinusIcon className="w-5 h-5" />
                                  <span className="hidden">{t("Reduce")}</span>
                                </button>
                                <input
                                  type="text"
                                  value={item.quantity}
                                  onChange={(e) => {
                                    const value = parseInt(e.target.value) || 0;
                                    updateItemQuantity(item.id, value);
                                  }}
                                  className="w-12 px-2 py-1 text-center"
                                />
                                <button
                                  onClick={() =>
                                    updateItemQuantity(
                                      item.id,
                                      item.quantity + 1
                                    )
                                  }
                                  className="px-2 py-1 bg-white border-l border-nobel"
                                >
                                  <PlusIcon className="w-5 h-5" />
                                  <span className="hidden">{t("Add")}</span>
                                </button>
                              </div>

                              <PriceLabel product={item} showCurrency={true} />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="pt-6">
                    <div className="flex justify-between py-4 border-t-2 border-yellow">
                      <div className="font-medium uppercase whitespace-nowrap">
                        {t("Subtotal")}
                      </div>
                      <div>{subtotal}</div>
                    </div>
                  </div>
                </>
              )}

              <Link
                className="w-full button"
                onClick={() => setCartOpen(false)}
                to="/cart"
              >
                {t("Go to cart")}
              </Link>
            </div>
          </div>
        </div>
      </Transition>
    </div>
  );
};

export default CartMobile;
